// extracted by mini-css-extract-plugin
export default {"TextContainer":"DrawerIntegrations_TextContainer__5Dv0G","ListText":"DrawerIntegrations_ListText__FZytF"};